/** @format */

import template from './gb-honour-roll-widget.html';
import './gb-honour-roll-widget.scss';
import moment, { min } from 'moment';
import faker from 'faker';

import { floor } from 'lodash';

export const GbHonourRollWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbWidget: '^^',
    },
    controller: class GbHonourRollWidgetComponent {
        constructor(
            $gbHonourRollActivity,
            $interval,
            $ccColors,
            $element,
            $ccToast,
            $ccRealtime,
            $log,
            $timeout,
            $scope,
            $rootScope
        ) {
            'ngInject';

            this.$interval = $interval;
            this.$ccColors = $ccColors;
            this.$element = $element;
            this.$gbHonourRollActivity = $gbHonourRollActivity;
            this.$ccToast = $ccToast;
            this.$ccRealtime = $ccRealtime;
            this.$log = $log;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$rootScope = $rootScope;

            this.loading = true;
            this.page = 1;
            this.honourRollActivities = [];
            this.honourRollActivitiesSyncParams = {
                limit: 20, //this limit will come from the widget
                offset: 0,
                ordering: '-created',
            };

            this.pusherActivities = [];
            this.oldestActivityIndex = 0;

            this.activitiesOnView = [];
            this.activityIndex = 0;
            this.canInterate = false;
        }
        $onInit() {
            if (this.gbWidget && this.gbWidget.widget && this.gbWidget.widget.uuid) {
                this.syncHonourRollActivities();
                this.setActivitiesOnView();
                this.initHonourRollActivitieaPusherChannel();
            }
        }

        syncHonourRollActivities() {
            this.honourRollActivitiesSyncParams['auction'] = this.gbApp.getAuctionUrl();
            this.honourRollActivitiesSyncParams['limit'] = this.gbWidget.widget.latest_activities;
            this.honourRollActivitiesSyncParams['widget'] = this.gbWidget.widget.uuid;
            return this.$gbHonourRollActivity
                .query(this.honourRollActivitiesSyncParams)
                .$promise.then((data) => {
                    this.$log.info('Synched Honour Roll Activities', data);
                    this.honourRollActivities = _.sortBy(data, 'created');

                    this.$timeout(() => {
                        this.canInterate = true;
                    });
                    this.adjustHonourRollList();
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        setActivitiesOnView() {
            const fakeActivitiesAmount = this.getActivitiesPerPage() + 2;
            for (let j = 0; j < fakeActivitiesAmount; j++) {
                let newActivity = new this.$gbHonourRollActivity({
                    uuid: faker.datatype.uuid(),
                    show: false,
                    created: new Date(moment([1990, 0, 1]).add(j, 'days').format('YYYY-MM-DD HH:mm:ss')),
                });

                this.activitiesOnView.push(newActivity);
            }
        }

        adjustHonourRollList() {
            if (this.honourRollActivities.length < this.activitiesOnView.length) {
                const difference = this.activitiesOnView.length - this.honourRollActivities.length;

                for (let j = 0; j < difference; j++) {
                    let newActivity = new this.$gbHonourRollActivity({
                        uuid: faker.datatype.uuid(),
                        rendered: false,
                        created: new Date(moment([1990, 0, 1]).add(j, 'days').format('YYYY-MM-DD HH:mm:ss')),
                    });

                    this.honourRollActivities.push(newActivity);
                }
            }
        }

        initHonourRollActivitieaPusherChannel() {
            let honourRollActivityChannel = `honour-roll-activity@${this.gbWidget.widget.uuid}`;

            this.honourRollActivityChannel = honourRollActivityChannel;
            this.$ccRealtime.register(this.honourRollActivityChannel);
            this.setCreateItemActivityListener();
            this.setDeleteItemActivityListener();
            this.createPreviewListener();
        }

        createPreviewListener() {
            if (this.gbApp.isEditMode()) {
                this.$rootScope.$on(this.gbApp.$honourRollPreviewEvent, (ev, data) => {
                    if (data.widget === this.gbWidget.widget.uuid) {
                        this.$timeout(() => {
                            this.$log.info('Showing Preview HonourRoll');
                            const minCardsOnView = this.getActivitiesPerPage() + 2;
                            this.activitiesOnView.length = 0;

                            for (let j = 0; j < minCardsOnView; j++) {
                                const amount = faker.datatype.number({
                                    min: 1,
                                    max: 100,
                                });
                                const alias = faker.datatype.number({
                                    min: 1,
                                    max: 100,
                                });
                                const created = moment().add(-1 * j, 'minutes');
                                const name = faker.lorem.words();
                                const profileName = `${faker.name.firstName()} ${faker.name.lastName()}`;

                                let fakeHonourRollActivity = new this.$gbHonourRollActivity({
                                    amount: amount,
                                    created: created,
                                    item_alias: alias,
                                    item_name: name,
                                    item_type: 'bidding',
                                    profile_full_name: profileName,
                                    uuid: faker.datatype.uuid(),
                                    widget_uuid: this.gbWidget.widget.uuid,
                                });

                                this.activitiesOnView.push(fakeHonourRollActivity);
                            }
                        });
                    }
                });
            }
        }

        setCreateItemActivityListener() {
            this.$ccRealtime.on('honourrollactivity.create', (ev, data) => {
                this.$log.info('Getting an Honour Roll Activity', ev, data);
                if (data.widget_uuid === this.gbWidget.widget.uuid) {
                    this.pusherActivities.push(new this.$gbHonourRollActivity(data));
                }
            });
        }

        setDeleteItemActivityListener() {
            this.$ccRealtime.on('honourrollactivity.delete', (ev, data) => {
                this.$log.info('Removing an Honour Roll Activity', ev, data);
                const fakeActivity = new this.$gbHonourRollActivity({
                    uuid: faker.datatype.uuid(),
                    'on-view': true,
                    rendered: true,
                    created: new Date(moment([1990, 0, 1]).format('YYYY-MM-DD HH:mm:ss')),
                });
                // remove from the backlog as well as
                // from the presenting list
                this.pusherActivities = this.pusherActivities.filter((activity) => activity.uuid !== data.uuid);

                const deletedActivity = this.honourRollActivities.find((activity) => activity.uuid === data.uuid);
                const index = this.honourRollActivities.indexOf(deletedActivity);
                this.honourRollActivities[index] = fakeActivity;
            });
        }

        getColumns() {
            return this.gbWidget.widget.columns;
        }

        getRows() {
            return this.gbWidget.widget.rows;
        }

        getWrapperClass() {
            let transition = this.gbWidget.widget.transition;

            if (['scroll-left', 'scroll-right'].includes(transition)) {
                return 'layout-row';
            }
        }

        getTableStyle() {
            let fullWidth;
            let transition = this.gbWidget.widget.transition;
            let direction = transition === 'scroll-left' || transition === 'scroll-top' ? 'normal' : 'reverse';

            fullWidth = (this.getActivityWidth() * (this.getActivitiesPerPage() + 2)) / this.getRows();

            if (transition === 'scroll-left' || transition === 'scroll-right') {
                let horizontalAnimation = `scrollHorizontal ${
                    this.gbWidget.widget.slide_interval * 1.5
                }s linear infinite ${direction}`;

                fullWidth = fullWidth + 'px';

                return {
                    '-webkit-animation': horizontalAnimation,
                    '-moz-animation': horizontalAnimation,
                    animation: horizontalAnimation,
                    minWidth: fullWidth,
                    width: fullWidth,
                };
            }

            if (transition === 'scroll-bottom' || transition === 'scroll-top') {
                let animation = `scrollVertical ${
                    this.gbWidget.widget.slide_interval * 1.5
                }s linear infinite ${direction}`;

                let style = {
                    '-webkit-animation': animation,
                    '-moz-animation': animation,
                    animation: animation,
                };

                return style;
            }
        }

        getActivityWidth() {
            const firstChild = this.$element[0].getElementsByTagName('div')[0];

            let wrapperWidth = firstChild.clientWidth;
            let itemWidth = wrapperWidth / this.getColumns();

            return itemWidth;
        }

        getActivityHeight() {
            const firstChild = this.$element[0].getElementsByTagName('div')[0];
            let wrapperHeight = firstChild.clientHeight;
            let itemHeight = (wrapperHeight / this.getActivitiesPerPage()) * this.getColumns();

            return itemHeight;
        }

        getActivityStyles() {
            let height = floor(this.getActivityHeight());
            let width = floor(this.getActivityWidth());

            height = height + 'px';
            width = width + 'px';

            const bgColor = (this.gbWidget && this.gbWidget.widget && this.gbWidget.widget.background_color) || '';

            return {
                width: width,
                height: height,
                maxHeight: height,
                maxWidth: width,
                minHeight: height,
                minWidth: width,
                backgroundColor: bgColor,
            };
        }

        getCardStyles(activity) {
            let height = floor(this.getActivityHeight());
            let width = floor(this.getActivityWidth());

            height = height + 'px';
            width = width + 'px';

            let styles = {};

            if (activity && activity.item_name) {
                styles['background-color'] = this.gbWidget.widget.table_background_color;
            } else {
                styles['display'] = 'inline-block';
            }

            styles['color'] = this.$ccColors.getContrast(styles['background-color']);
            styles['height'] = height;
            styles['maxHeight'] = height;
            styles['minHeight'] = height;
            styles['width'] = width;
            styles['maxWidth'] = width;
            styles['minWidth'] = width;

            return styles;
        }

        getActivitiesPerPage() {
            return this.getColumns() * this.getRows();
        }

        $onDestroy() {}

        setRenderedCallback(index) {
            const activity = this.activitiesOnView[index];

            if (activity && this.canInterate) {
                this.activitiesOnView[index] = angular.copy(this.honourRollActivities[this.activityIndex]);

                this.activityIndex += 1;

                if (this.activityIndex === this.honourRollActivities.length) {
                    this.activityIndex = 0;
                }
                this.$scope.$apply();

                // then check if there is anything on the backlog to be shown
                this.honourRollActivities[this.activityIndex]['rendered'] = true;
                this.checkHonourRollBacklog();
            }
        }

        checkHonourRollBacklog() {
            if (this.pusherActivities.length > 0) {
                const newActivity = this.pusherActivities[0];

                const activityExists = this.honourRollActivities.find(
                    (activity) => activity && activity.uuid === newActivity.uuid
                );
                // it should avoind any edge case when the same activity can be shown twice
                if (activityExists) {
                    // remove it from the backlog
                    this.pusherActivities.shift();
                    return;
                }

                const anyDummybActivity = this.honourRollActivities.find((activity) => activity && !activity.item_name);

                if (this.honourRollActivities.length < this.gbWidget.widget.latest_activities && !anyDummybActivity) {
                    this.honourRollActivities.push(newActivity);
                    // remove it from the backlog
                    this.pusherActivities.shift();
                } else {
                    let oldestActivity = this.honourRollActivities.reduce((oldest, currentActivity) => {
                        return new Date(oldest.created) < new Date(currentActivity.created) ? oldest : currentActivity;
                    });
                    // the oldest element has been shown??
                    if (oldestActivity['rendered']) {
                        const index = this.honourRollActivities.indexOf(oldestActivity);
                        this.honourRollActivities[index] = newActivity;
                        // remove it from the backlog
                        this.pusherActivities.shift();
                    }
                }
            }
        }
    },
};
